import React, { useState } from 'react';

var styles = {"image":"_2hdkJ","playButton":"_16Q0f"};

var Youtube = function Youtube(props) {
  var videoId = props.videoId,
      width = props.width,
      height = props.height,
      imgSize = props.imgSize;

  var _useState = useState(false),
      showVideo = _useState[0],
      setShowVideo = _useState[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, showVideo ? /*#__PURE__*/React.createElement("iframe", {
    width: width || '100%',
    height: height || '400px',
    src: "https://www.youtube.com/embed/" + videoId + "?autoplay=1&showinfo=0",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    allowFullScreen: true
  }) : /*#__PURE__*/React.createElement("div", {
    className: styles.image,
    style: {
      backgroundImage: "url(" + ("https://img.youtube.com/vi/" + videoId + "/" + (imgSize || 'mqdefault') + ".jpg") + ")",
      width: width,
      height: height
    },
    onClick: function onClick() {
      return setShowVideo(true);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.playButton
  })));
};

export default Youtube;
//# sourceMappingURL=index.modern.js.map
